<template>
  <div class="home-page">
    <top-bar :topbarList="topbarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      projectConfig: (state) => state.projectConfig,
    }),
    topbarList() {
      let topbarList = [
        {
          name: `${this.projectConfig.appName}后台`,
          isActive: false,
          path: "/",
          childrenPath: ["/home/order"],
        },
      ];
      if (this.isDsType && this.$route.path == "/") {
        this.$router.push({
          path: "/dsHome",
        });
      }
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.home-page {
  height: 100%;
  min-width: 1500px;
}
</style>
